import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { Select } from 'mailup-web-components'

import type { CritType } from 'Pages/RecipientsList/model'

import { changeCriterionTypeCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { critTypeState } from 'Pages/RecipientsList/recoil/state/filters'
import { gainsightTrack } from 'mailup-react-helpers'
import { useRecoilCallback, useRecoilValue } from 'recoil'
interface InputCritTypeProps {
  index: number
}

const InputCritType: FC<InputCritTypeProps> = ({ index }) => {
  const intl = useIntl()
  const critType = useRecoilValue(critTypeState(index))

  const changeCriterionType = useRecoilCallback(changeCriterionTypeCallback, [])

  const options = [
    {
      value: 'groups',
      label: intl.formatMessage({ id: 'Load.RecipientsList.CritTypeGroups' }),
    },
    {
      value: 'filters',
      label: intl.formatMessage({ id: 'Load.RecipientsList.CritTypeFilters' }),
    },
    {
      value: 'anagraphicField',
      label: intl.formatMessage({
        id: 'Load.RecipientsList.CritTypeAnagraphicField',
      }),
    },
    {
      value: 'optinDate',
      label: intl.formatMessage({
        id: 'Load.RecipientsList.CritTypeOptinDate',
      }),
    },
    {
      value: 'pendingDate',
      label: intl.formatMessage({
        id: 'Load.RecipientsList.CritTypePendingDate',
      }),
    },
    {
      value: 'optoutDate',
      label: intl.formatMessage({
        id: 'Load.RecipientsList.CritTypeOptoutDate',
      }),
    },
    {
      value: 'optoutType',
      label: intl.formatMessage({
        id: 'Load.RecipientsList.CritTypeOptoutType',
      }),
    },
    {
      value: 'optoutMessage',
      label: intl.formatMessage({
        id: 'Load.RecipientsList.CritTypeOptoutMessage',
      }),
    },
  ]

  const handleChange = (value: CritType): void => {
    if (value === 'optinDate') {
      gainsightTrack(
        'mup_recipients_click_searchSelectSubscriptionDateSelectOption',
        {
          commercialOfferName: 'mup',
        },
      )
    }
    if (value === 'groups') {
      gainsightTrack('mup_recipients_click_searchSelectGroup', {
        commercialOfferName: 'mup',
      })
    }
    if (value === 'filters') {
      gainsightTrack('mup_recipients_click_searchFiltersSelectOption', {
        commercialOfferName: 'mup',
      })
    }
    if (value === 'anagraphicField') {
      gainsightTrack('mup_recipients_click_searchRecipientsFieldSelectOption', {
        commercialOfferName: 'mup',
      })
    }
    if (value === 'optoutType') {
      gainsightTrack(
        'mup_recipients_click_searchUnsubscriptionCauseSelectOption',
        {
          commercialOfferName: 'mup',
        },
      )
    }
    if (value === 'optoutDate') {
      gainsightTrack(
        'mup_recipients_click_searchUnsubscriptionDateSelectOption',
        {
          commercialOfferName: 'mup',
        },
      )
    }
    if (value === 'optoutMessage') {
      gainsightTrack(
        'mup_recipients_click_searchUnsubscriptionFromSelectOption',
        {
          commercialOfferName: 'mup',
        },
      )
    }
    if (value === 'optoutMessage') {
      gainsightTrack(
        'mup_recipients_click_searchRequestSubscriptionDateSelectOption',
        {
          commercialOfferName: 'mup',
        },
      )
    }

    if (value !== undefined) {
      void changeCriterionType(value, index)
    } else {
      void changeCriterionType('undefined', index)
    }
  }

  return (
    <Select
      value={critType}
      options={options}
      placeholder={intl.formatMessage({
        id: 'Load.RecipientsList.SelectCritTypePlaceholder',
      })}
      onChange={handleChange}
    />
  )
}

export default InputCritType
